import useReffrom, { useRef } from 'react';
import { ContainerField, FieldError } from '../../../style';
import { SwitchContainer } from './style';
import Switch from 'rc-switch';
import { useGlobal } from '../../../hooks/global';

interface InputSwitchProps {
    checked: boolean;
    isDisabled: boolean;
    defaultValue?: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    label?: string;
    className?: string;
    error?: string;
}

const InputSwitch = ({
    error,
    isDisabled,
    defaultValue,
    onChange,
    checked,
    ...rest
}: InputSwitchProps) => {
    const { theme } = useGlobal();

    const input_ref = useRef<any>();

    return (
        <ContainerField>
            <SwitchContainer>
                <Switch
                    id="tooltip_switch"
                    className="custom-switch custom-switch-primary custom-switch-medium"
                    checked={checked}
                    onChange={(value) => onChange(value)}
                    ref={input_ref}
                    {...rest}
                />
            </SwitchContainer>

            {error && !isDisabled && (
                <FieldError title={error}>{error}</FieldError>
            )}
        </ContainerField>
    );
};

export default InputSwitch;